module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iYRKK"))).then(() => parcelRequire('3a9aZ'));